"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartileButton = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const StyledCartileButton = components_core_1.styled.a `
  width: 100%;
  min-height: 32px;
  padding-top: 1px;
  border: 1px solid;
  border-radius: 16px;
  outline: none;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

    & {
    cursor: pointer;
    background: transparent;
    border-color: ${props => props.theme.colors.content.primary};
    color: ${props => props.theme.colors.content.primary};
  }

  @media (hover: hover) {
    :hover,
    :focus {
      background: transparent;
      border-color: ${props => props.theme.colors.border.hover};
      color: ${props => props.theme.colors.content.hover};
    }
  }
`;
function CartileButton({ children, navigationTarget }) {
    return (react_1.default.createElement(StyledCartileButton, { onClick: navigationTarget.onClick, href: navigationTarget.href, className: "cartile-button-container" },
        react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.label150, color: components_core_1.TokenTextColor.inherit, tag: components_core_1.TextTag.span }, children)));
}
exports.CartileButton = CartileButton;
